import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  deleteFinancialYear,
  deleteTransactionRelation,
  deleteTransactionRelationByObjectAttribute,
} from "../../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};

const DeleteLinkToPayment = ({
  open,
  setOpen,
  ObjectAttribute,
  transId,
  objectID,
  InvID,
  rows,
  setRows,
  setDeleteEvent,
  entryRows,
  setEntryRows,
  setsuccessSnakbar,
  setSnakbarTex,
}) => {
  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  useEffect(() => {
    setDeleteEvent(false);
  }, [open]);

  async function deleteItem() {
    try {
      setLoading(true);
      console.log("ObjectID", objectID);
      console.log("transid", transId);
      console.log("ObjectArrr", ObjectAttribute);

      // const deleteRelationData = await API.graphql(
      //   graphqlOperation(deleteTransactionRelationByObjectAttribute, {
      //     ObjectAttribute: ObjectAttribute,
      //     ObjectID: objectID,
      //     TransactionID: transId,
      //   })
      // );
      const deleteRelationData = await API.graphql(
        graphqlOperation(deleteTransactionRelation, {
          ObjectID: objectID,
          TransactionID: transId,
        })
      );
      console.log("deleteRelationData", deleteRelationData);
      setOpen(false);
      setLoading(false);
      setDeleteEvent(true);
      //    }
    } catch (error) {
      console.log("error", error);
    }
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            backgroundColor: "white",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography sx={{ color: "rgb(60 60 60)", fontWeight: "bold" }}>
            Do you want to unlink this entry?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // flexDirection: { xs: "column", sm: "row" },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            disabled={loading}
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => deleteItem()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
};

export default DeleteLinkToPayment;
